var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row justify-content-center align-items-center" },
      [
        _vm.icon
          ? _c("div", { staticClass: "col-12 text-center" }, [
              _c("i", {
                staticClass: "fa",
                class: _vm.icon + " " + _vm.iconClass,
                staticStyle: { "font-size": "4em" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col my-auto" }, [
                _c(
                  "h4",
                  { staticClass: "regular text-gray align-middle my-auto" },
                  [_vm._t("default")],
                  2
                ),
              ]),
            ])
          : _c("div", { staticClass: "col-12 text-center" }, [
              _c("img", {
                class: _vm.imgClass,
                staticStyle: {
                  height: "4em",
                  width: "auto",
                  "max-height": "unset",
                  "max-width": "unset",
                },
                attrs: {
                  height: "2em",
                  src: _vm.imgSrc,
                  alt: _vm.$t("global.phrases.noResultsFound"),
                },
              }),
              _vm._v(" "),
              _c(
                "h5",
                { class: _vm.textClass, style: _vm.textStyle },
                [_vm._t("default")],
                2
              ),
            ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }